import { ItemLabel } from '@axo/ui-core/components/__annotation__';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Meta, StoryObj } from '@storybook/react';
import trustpilotMock from './__mocks__/TrustPilot.mock.json';
import { TrustPilotWidget, variants } from './TrustPilotWidget';
import { Markets } from './TrustPilotWidget.types';

const meta: Meta<typeof TrustPilotWidget> = {
  component: TrustPilotWidget,
  title: 'Features/content/TrustPilot Widget',
  argTypes: {
    market: {
      control: { type: 'select' },
      options: Markets,
    },
    variant: {
      control: { type: 'select' },
      options: variants,
    },
    showNumberOfReviews: {
      control: { type: 'boolean' },
    },
  },
};

export default meta;
type Story = StoryObj<typeof TrustPilotWidget>;

export const Default: Story = {
  args: {
    market: 'no',
    variant: 'combo-inline',
    showNumberOfReviews: true,
    data: trustpilotMock,
  },
};

export const Variants: Story = {
  args: {
    ...Default.args,
  },
  render: (args) => (
    <Stack gap={'l'}>
      {variants.map((variant) => (
        <ItemLabel key={variant} label={variant} as={'span'}>
          <TrustPilotWidget {...args} variant={variant} />
        </ItemLabel>
      ))}
    </Stack>
  ),
};

export const Responsive: Story = {
  args: {
    ...Default.args,
  },
  render: (args) => (
    <Stack gap={'l'}>
      {['desktop', 'mobile'].map((variant) => (
        <div
          key={variant}
          style={variant === 'mobile' ? { maxWidth: 350 } : undefined}
        >
          <ItemLabel label={variant} as={'span'}>
            <TrustPilotWidget {...args} variant="responsive" />
          </ItemLabel>
        </div>
      ))}
    </Stack>
  ),
};

export const NoTrustScore: Story = {
  args: {
    ...Default.args,
    data: {
      ...trustpilotMock,
      businessEntity: { ...trustpilotMock.businessEntity, trustScore: 4.4 },
    },
  },
};